<template>
  <div class="signup">
    <div v-if="flag == 0">
      <div class="signup-interviewer p-4">
        <div class="work-card mb-6" v-for="(item, index) in taskData" :key="index" v-loading="cardLoading">
          <div class="top-content flex justify-between items-center bg-card-bg-gray p-4 pt-2">
            <!-- 左边文字 -->
            <div class="left-content">
              <div>
                <!-- <div class="inline-block"> -->
                <div class="text-medium-x font-bold inline-block left-name">{{ item.name }}</div>
                <!-- </div>  -->
                <div class="inline-block mx-1 status-text">
                  <div v-if="item.status == 100" class="" style="background: #00be6a"><span>审核中</span></div>
                  <div v-if="item.status == 200" class="" style="background: #e8a31b"><span>招募中</span></div>
                  <div v-if="item.status == 300" class="" style="background: #e34152"><span>审核拒绝</span></div>
                  <div v-if="item.status == 400" class="" style="background: #6c748a"><span>报名结束</span></div>
                </div>
              </div>
              <div class="mt-2 text-medium" style="color: rgba(0, 0, 0, 0.65)">
                <span class="mr-8">报名数：{{ item.joinQuantity }}</span>
                <span class="mr-8">已选中：{{ item.selectedQuantity }}</span>
                <span>待处理：{{ item.unselectedQuantity }}</span>
              </div>
            </div>
            <!-- 右边按钮 -->
            <div class="right-content">
              <el-button type="text" @click="recruitInfo(item)">招募信息</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="closeRecruit(item.id)" v-if="item.status == 200">关闭招募</el-button>
            </div>
          </div>
          <div class="p-4">
            <!-- 搜索框和下拉框 -->
            <div class="input-group mb-2">
              <el-input placeholder="调查员姓名" v-model="item.interviewerName" :style="{ width: '128px' }"> </el-input>
              <el-input placeholder="调查员手机号" v-model="item.interviewerPhone" :style="{ width: '128px' }"> </el-input>
              <el-select v-model="item.sex" placeholder="性别" :style="{ width: '128px' }">
                <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
              <el-select v-model="item.area" placeholder="执行地区" :style="{ width: '128px' }">
                <el-option v-for="item in areaOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
              <el-select v-model="item.age" placeholder="年龄" :style="{ width: '128px' }">
                <el-option v-for="item in ageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
              <el-select v-model="item.selectedStatus" placeholder="状态" :style="{ width: '128px' }">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
              <div class="inline-block" style="width: 140px">
                <el-button class="mr-0.5" type="primary" @click="toSearch(item)">
                  <span class="px-0.5">查询</span>
                </el-button>
                <el-button size="small" @click="onReset(item)">
                  <span class="px-0.5">重置</span>
                </el-button>
              </div>
            </div>

            <!-- table -->
            <div class="bottom-table">
              <el-table
                class="data-table mb-3"
                :data="item.interviewerList"
                style="width: 100%"
                tooltip-effect="light"
                @selection-change="selectionChangeHandler(item.id)"
                :ref="item.id"
              >
                <el-table-column type="selection" :selectable="selectableHandler"> </el-table-column>
                <el-table-column prop="name" label="调查员姓名" align="center" width="100">
                  <template slot-scope="scope">
                    {{ scope.row.interviewerName ? scope.row.interviewerName : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="contact" label="手机号" align="center" width="200"> </el-table-column>
                <el-table-column prop="sex" label="性别" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.sex === 1 ? '男' : scope.row.sex == 2 ? '女' : '-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="age" label="年龄" align="center">
                  <template slot-scope="scope">
                    {{
                      scope.row.age == 1
                        ? '18岁以下'
                        : scope.row.age == 2
                        ? '18~25岁'
                        : scope.row.age == 3
                        ? '26~30岁'
                        : scope.row.age == 4
                        ? '31~40岁'
                        : scope.row.age == 5
                        ? '41~50岁'
                        : scope.row.age == 6
                        ? '51~60岁'
                        : scope.row.age == 7
                        ? '60岁以上'
                        : '-'
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="workCityList" label="执行地区" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.workCityList == null ? '-' : scope.row.workCityList.join('、') }}
                    <!-- {{ typeof scope.row.workCityList }} -->
                  </template>
                </el-table-column>
                <el-table-column prop="education" label="学历" align="center">
                  <template slot-scope="scope">
                    {{ educationInfo(scope.row.education) }}
                  </template>
                </el-table-column>
                <el-table-column prop="goodAtList" label="专业擅长" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.goodAtList == null ? '-' : scope.row.goodAtList.join('、') }}
                  </template>
                </el-table-column>
                <!-- 添加三种结算字段 -->

                <el-table-column prop="settleMode" label="结算方式" align="center" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.settleMode === 1">按答卷数量</span>
                    <span v-else-if="scope.row.settleMode === 2">按天</span>
                    <span v-else-if="scope.row.settleMode === 3">按阶梯计价</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="expectedQuantity" label="数量" align="center" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.settleRule"
                      >{{ scope.row.settleRule.expectedQuantity }} {{ scope.row.settleMode === 1 ? '份' : '天' }}</span
                    >
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="unitPriceYuan" label="单价" align="center" width="180">
                  <template slot-scope="scope">
                    <div v-if="scope.row.settleMode === 1">{{ scope.row.settleRule.unitPriceYuan }}元/份</div>
                    <div v-else-if="scope.row.settleMode === 2">{{ scope.row.settleRule.unitPriceYuan }}元/天</div>
                    <div v-else-if="scope.row.settleMode === 3">
                      <!-- 100.00～200.00元/份 -->
                      {{ scope.row.settleRule.tiers[0].unitPriceYuan }}~{{
                        scope.row.settleRule.tiers[scope.row.settleRule.tiers.length - 1].unitPriceYuan
                      }}元/份
                      <el-tooltip placement="top" effect="dark">
                        <div slot="content">
                          <div v-for="(it, i) in scope.row.settleRule.tiers" :key="i">
                            <p :style="{ marginBottom: i === scope.row.settleRule.tiers.length - 1 ? '0' : '5px' }">
                              <span>{{ it.quantityLowerBound }}份</span>
                              ~
                              <span>{{ it.quantityUpperBound }}</span
                              >份,
                              <span style="margin-left: 3px">{{ it.unitPriceYuan }}元/份</span>
                            </p>
                          </div>
                        </div>
                        <!-- <i class="iconfont">&#xe63d;</i> -->
                        <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-medium"></i>
                      </el-tooltip>
                    </div>
                    <div v-else>-</div>
                  </template>
                </el-table-column>

                <el-table-column prop="shopHasProxyJobCreateAt" label="报名时间" align="center" width="200"> </el-table-column>
                <el-table-column prop="shopHasProxyJobStatus" label="状态" align="center" width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.shopHasProxyJobStatus == '100'">
                      <span class="mr-0.5" style="color: rgba(0, 0, 0, 0.15)">●</span>
                      <span style="color: #6c748a">未处理</span>
                    </div>
                    <div v-else-if="scope.row.shopHasProxyJobStatus == '200'">
                      <span class="mr-0.5" style="color: #00be6a">●</span>
                      <span style="color: #00be6a">已选中</span>
                    </div>
                    <div v-else-if="scope.row.shopHasProxyJobStatus == '300'">
                      <span class="mr-0.5" style="color: #e34152">●</span>
                      <span style="color: #e34152">已淘汰</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="option" label="操作" align="center" width="150" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="distributeWork(item, 'single', scope.row)"
                      v-if="scope.row.shopHasProxyJobStatus == 100 || scope.row.shopHasProxyJobStatus == 200"
                      >分配任务</el-button
                    >
                    <el-button
                      type="text"
                      @click="outInterviewer(item.id, scope.row)"
                      v-if="scope.row.shopHasProxyJobStatus == 100"
                      >淘汰</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="primary" class="distribute" @click="distributeWork(item.id, 'many', item)">分配任务</el-button>
            </div>
          </div>
        </div>

        <!-- 查看招募信息的 dialog -->
        <el-drawer
          title="招募信息"
          :visible.sync="recruitInfoDialogVisible"
          size="60%"
          :destroy-on-close="true"
          :before-close="handleClose"
        >
          <div v-loading="dialogLoading" class="flex flex-col pb-4" style="min-height: calc(100vh - 114px)">
            <div class="px-6 pt-6">
              <div class="dialog-content-top">
                <div class="content-top-title font-bold flex justify-between text-medium-x text-theme-black-850">
                  <div style="width: 86%">{{ currentRecruitTaskDetail.name }}</div>
                  <div class="imgDiv">
                    <img src="@/assets/img/random-interview/shenhe.png" v-if="currentTaskStatus == 100" />
                    <img src="@/assets/img/random-interview/doing.jpg" v-else-if="currentTaskStatus == 200" />
                    <img src="@/assets/img/random-interview/refuse.jpg" v-else-if="currentTaskStatus == 300" />
                    <img src="@/assets/img/random-interview/end.jpg" v-else-if="currentTaskStatus == 400" />
                  </div>
                </div>
                <div class="content-top-info">
                  <el-row>
                    <el-col :span="13"
                      ><div class="grid-content"><span>任务截止时间：</span>{{ currentRecruitTaskDetail.endAt }}</div></el-col
                    >
                    <el-col :span="11"
                      ><div class="grid-content"><span>报名截止时间：</span>{{ currentRecruitTaskDetail.joinEndAt }}</div></el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="24"
                      ><div class="grid-content wj-count">
                        <span>问卷题目数：</span>{{ currentRecruitTaskDetail.titleAmount }}
                      </div></el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="24"
                      ><div class="grid-content work-detail">
                        <span>任务描述：</span>{{ currentRecruitTaskDetail.describe }}
                      </div></el-col
                    >
                  </el-row>
                </div>
              </div>

              <div class="dialog-content-bottom">
                <div class="content-bottom-title flex justify-between items-center">
                  <div class="font-bold text-medium-x text-theme-black-850 mb-3">工作地区（最多可选择5个地区）</div>
                  <div>
                    <span class="text-medium text-theme-black-850"
                      ><span class="text-theme-black-450">任务总价（元）：</span>{{ currentRecruitTaskDetail.totalPrice }}</span
                    >
                    <span class="ml-6 text-medium text-theme-black-850"
                      ><span class="text-theme-black-450">任务总数量：</span>{{ currentRecruitTaskDetail.totalAmount }}</span
                    >
                  </div>
                </div>

                <div class="content-bottom-table">
                  <el-table class="data-table" :data="currentRecruitTaskDetail.workArea" style="width: 100%">
                    <el-table-column prop="serialNo" label="序号" align="center"> </el-table-column>
                    <el-table-column prop="name" label="工作地区" align="center"> </el-table-column>
                    <el-table-column prop="amount" label="数量" align="center"> </el-table-column>
                    <el-table-column prop="price" label="单价" align="center"> </el-table-column>
                    <el-table-column prop="note" label="备注" align="center"> </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-footer">
            <el-button @click="changeRecruitInfo">修改信息</el-button>
            <el-button type="primary" @click="recruitInfoDialogVisible = false" style="width: 88px">关闭</el-button>
          </div>
        </el-drawer>

        <!-- 修改招募信息的dialog -->
        <el-dialog
          title="招募信息修改"
          class="theme-dialog dialog-center dialog-body-0"
          top="0"
          :visible.sync="changeRecruitInfoDialogVisible"
          :before-close="handleChangeRecruitInfoClose"
          :destroy-on-close="true"
          custom-class="recruit-info"
          width="80%"
        >
          <recruitment-form :id="Number(currentRecruitTaskDetail.id)" @cancel="handleChangeRecruitInfoClose" />
          <!-- <span slot="footer" class="dialog-footer block self-end mt-4">
            <el-button @click="changeRecruitInfoDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="changeRecruitInfoDialogVisible = false">确 定</el-button>
          </span> -->
        </el-dialog>
      </div>
    </div>

    <div v-else-if="flag == 1" class="mt-4">
      <!-- 分配任务 -->
      <assign-task @comeback="comebackHandler" :data="selectioned" :title="title" :id="recruitTaskId" />
    </div>

    <div v-else-if="flag == 2">
      <el-empty class="pt-40" description="目前暂无招募任务信息"></el-empty>
    </div>
  </div>
</template>

<script>
import assignTask from './AssignTask.vue'
import { cityList } from './cityList.js'
import recruitmentForm from './RecruitmentForm.vue'
import {
  getRecruitTaskList,
  getRecruitTaskDetail,
  closeRecruitTask,
  weedOutInterviewer,
  getRecruitTaskInterviewersInfo
} from '@/api/wenjuan/offline.js'
import GlobalConfig from '@/global/config'

export default {
  name: 'SignupInterviewer',
  components: {
    assignTask,
    recruitmentForm
  },
  data() {
    return {
      selectioned: new Map(),
      title: '', // 保存招募任务的标题
      curId: '', // 当前招募详情id
      currentTaskStatus: '', // 点击了招募信息后 保存一下当前任务的状态
      currentTaskInfo: '', // 点击分配任务 保存当前招募任务信息
      dialogLoading: false,
      cardLoading: false,
      flag: 0,
      // interviewerName: '',
      // interviewerPhone: '',
      recruitTaskId: '', // 招募任务id 用于传给分配任务组件用
      recruitInfoDialogVisible: false, // 查看招募信息框
      changeRecruitInfoDialogVisible: false, // 修改招募信息框
      currentRecruitTaskDetail: {},
      // sex: '',
      // area: '',
      // age: '',
      // status: '',
      taskData: '',
      sexOptions: [
        {
          label: '男',
          value: 1
        },
        {
          label: '女',
          value: 2
        }
      ],
      areaOptions: [],
      ageOptions: [
        {
          label: '18岁以下',
          value: 1
        },
        {
          label: '18-25岁',
          value: 2
        },
        {
          label: '26-30岁',
          value: 3
        },
        {
          label: '31-40岁',
          value: 4
        },
        {
          label: '41-50岁',
          value: 5
        },
        {
          label: '51-60岁',
          value: 6
        },
        {
          label: '60岁以上',
          value: 7
        }
      ],
      statusOptions: [
        {
          label: '未处理',
          value: 100
        },
        {
          label: '已选中',
          value: 200
        },
        {
          label: '已淘汰',
          value: 300
        }
      ]
    }
  },
  created() {
    this.getTaskData()
    // this.handlerSum();

    // 处理地区选项
    // 单独处理全国这一种情况 因为引用的是姜姐的配置 需要自己单独加 否则会影响其他文件
    this.areaOptions.push({
      label: '全国',
      value: '全国'
    })
    cityList.forEach(item => {
      item.city.forEach(n => {
        this.areaOptions.push({
          label: item.province + n,
          value: item.province + n
        })
      })
    })
  },
  methods: {
    async getTaskData() {
      this.taskData = []
      let res = await getRecruitTaskList({
        surveyId: GlobalConfig.getSurveyId()
      })
      if (!res.data.data) {
        this.flag = 2
        return
      }
      this.taskData =
        res.data.data &&
        res.data.data.map(item => {
          item.interviewerName = ''
          item.interviewerPhone = ''
          item.sex = ''
          item.area = ''
          item.age = ''
          item.selectedStatus = ''
          return item
        })

      this.handlerSum()
    },
    handleClose() {
      this.recruitInfoDialogVisible = false
    },
    // 【招募信息按钮】
    recruitInfo(item) {
      this.dialogLoading = true
      this.recruitInfoDialogVisible = true

      // 保存一下当前招募任务的状态
      this.currentTaskStatus = item.status
      this.curId = item.id
      this.getRecruitTaskDetail()
    },
    getRecruitTaskDetail() {
      getRecruitTaskDetail({ id: this.curId })
        .then(res => {
          this.currentRecruitTaskDetail = res.data.data
          this.currentRecruitTaskDetail.totalPrice = this.currentRecruitTaskDetail.totalAmount = 0
          if (res.data.data.workArea.length !== 0) {
            res.data.data.workArea.forEach(item => {
              this.currentRecruitTaskDetail.totalAmount += item.amount
              this.currentRecruitTaskDetail.totalPrice += item.amount * item.price
            })
          }
        })
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.dialogLoading = false
        })
    },
    // 分配任务
    distributeWork(id, ...end) {
      this.recruitTaskId = ''
      this.title = ''
      if (end[0] == 'many') {
        if (!this.$refs[id][0].selection.length) {
          this.$message.error('请勾选当前招募任务下的调查员！')
          return
        }
        this.selectioned.clear()
        this.$refs[id][0].selection.forEach(item => {
          this.selectioned.set(item.contact, item)
        })

        this.title = end[1].name
        this.recruitTaskId = id
      } else if (end[0] == 'single') {
        // console.log('分配单人任务');
        // this.selectioned.clear();
        // console.log(id);
        this.selectioned.clear()
        this.title = id.name
        this.recruitTaskId = id.id
        this.selectioned.set(end[1].contact, end[1])
        // console.log(end[1]);
      }
      // 切换到分配任务组件
      this.flag = 1
    },
    comebackHandler() {
      this.getTaskData()
      this.flag = 0
    },
    // 修改招募信息
    changeRecruitInfo() {
      this.changeRecruitInfoDialogVisible = true
    },
    // 修改招募信息框的关闭处理函数
    handleChangeRecruitInfoClose() {
      this.changeRecruitInfoDialogVisible = false
      this.getRecruitTaskDetail()
    },
    // 关闭招募按钮处理函数
    closeRecruit(id) {
      this.cardLoading = true
      closeRecruitTask(id)
        .then(res => {
          this.getTaskData()
          this.$message.success('关闭招募成功！')
        })
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.cardLoading = false
        })
    },
    // 淘汰调查员函数
    outInterviewer(proxyJobId, row) {
      weedOutInterviewer({ userId: row.userId, proxyJobId })
        .then(res => {
          if (res.data.code == 0) {
            // 将本地的状态改变 不调用接口 因为成功了 这个地方肯定是300 也就不用刷新页面了 好的用户体验
            row.shopHasProxyJobStatus = 300
            this.handlerSum()
            this.$message.success('淘汰调查员成功！')
            // this.getTaskData();
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    // 选中项变化触发的函数
    selectionChangeHandler(id) {},
    toSearch(item) {
      this.inputValueChangeHandler(item)
      console.log(item.name, this.$route.params.id)
    },
    onReset(item) {
      item.interviewerName = ''
      item.interviewerPhone = ''
      item.sex = ''
      item.area = ''
      item.age = ''
      item.selectedStatus = ''
      this.toSearch(item)
    },
    // 选择条件变化触发的函数
    inputValueChangeHandler(item) {
      let params = {
        taskId: item.id,
        surveyId: this.$route.params.id,
        taskName: item.name
      }
      item.interviewerName && (params.name = item.interviewerName)
      item.interviewerPhone && (params.phone = item.interviewerPhone)
      item.sex && (params.sex = item.sex)
      item.area && (params.workCity = item.area)
      item.age && (params.age = item.age)
      item.selectedStatus && (params.shopHasProxyJobStatus = item.selectedStatus)
      getRecruitTaskInterviewersInfo(params)
        .then(res => {
          item.interviewerList = res.data.data
          //this.$message.success('查询成功！')
        })
        .catch(e => {
          this.$message.error(e.message)
        })
    },
    educationInfo(education) {
      if (education == 1) {
        return '高中及以下'
      } else if (education == 2) {
        return '大专'
      } else if (education == 3) {
        return '本科'
      } else if (education == 4) {
        return '硕士及以上'
      } else {
        return '-'
      }
    },
    // 判断哪行可以选中
    selectableHandler(row, index) {
      // 已淘汰的人不可以分配任务
      if (row.shopHasProxyJobStatus == 300) {
        return false
      } else {
        return true
      }
    },
    // 计算待处理数
    handlerSum() {
      let count = 0
      // this.$nextTick(() => {
      // console.log(this.taskData);
      this.taskData &&
        this.taskData.forEach(item => {
          item.interviewerList.forEach(n => {
            if (n.shopHasProxyJobStatus == 100) {
              count++
            }
          })
        })
      // console.log('count:', count);
      this.$emit('handlerSum', count == 0 ? '' : count)
      // })
    }
  },
  watch: {
    recruitInfoDialogVisible(newVal) {
      if (newVal == false) {
        this.currentRecruitTaskDetail = {}
        this.currentTaskStatus = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signup {
  position: relative;
  min-height: calc(100vh - 400px);
  .signup-interviewer {
    .work-card {
      border: 1px solid #d8d8d8;
      border-radius: 2px;
      .input-group {
        .el-input,
        .el-select {
          margin-right: 12px;
        }
      }
      .bottom-table {
      }
    }

    // dialog 样式
    .dialog-content-top {
      .content-top-title {
        position: relative;
        .imgDiv {
          width: 101px;
          height: 90px;
          position: absolute;
          top: 20%;
          right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .content-top-info {
        .wj-count {
          margin-left: 14px;
        }
        .work-detail {
          margin-left: 28px;
        }
        .el-row {
          @apply my-4;
        }
        .grid-content {
          @apply text-theme-black-850;
          span {
            @apply text-medium text-theme-black-450;
          }
        }
      }
    }

    .dialog-content-bottom {
      @apply mt-9;
    }
  }
}
.status-text {
  div {
    @apply text-small;
    height: 22px;
    border-radius: 2px;
    color: #fff;
    font-weight: 500;
    text-align: center;
    padding: 1px 10px;
    line-height: 22px;
  }
}
.left-name {
  position: relative;
  top: 12px;
  max-width: 700px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 25px;
}
.right-content {
  position: relative;
  top: 5px;
}
.drawer-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 0;
  width: 100%;
}
::v-deep .el-drawer__body {
  position: relative;
}
.btn-footer {
  @apply h-16 flex items-center justify-end pr-6;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
